/**
 * Show Services
 * @param {Number} id category ID
 */

export default function (id) {
    if (id) {
        $('.js-archive-service-card').hide(0);
        $('.js-archive-service-card').addClass('hidden');

        $('.js-archive-service-card').each(function (index, card) {
            let cardTypeIds = JSON.parse('[' + $(card).data('type') + ']');

            $(cardTypeIds).each(function (key, typeId) {
                if (id === parseInt(typeId)) {
                    $(card).show(0);
                    $(card).removeClass('hidden');
                }
            });
        });
    } else {
        $('.js-archive-service-card').show(0);
        $('.js-archive-service-card').removeClass('hidden');
    }
}
